<template>
    <DxPopup :visible="visible" :show-title="true" :drag-enabled="true" :resize-enabled="false"
        :show-close-button="false" :close-on-outside-click="false" :width="680" :height="'auto'"
        @hidden="emit('update:visible', false)">
        <template #title>
            <div class="popup-header">
                <div class="popup-header-main">
                    <span class="dx-icon dx-icon-add popup-header-icon" />
                    <div class="popup-header-texts">
                        <div class="popup-header-title">Comandă nouă</div>
                        <div class="popup-header-subtitle">{{ tipComandaDenumire || 'Selectați tipul comenzii' }}</div>
                    </div>
                </div>
                <span class="header-close" @click="emit('update:visible', false)">×</span>
            </div>
        </template>

        <DxToolbarItem widget="dxButton" toolbar="bottom" location="after"
            :options="{ text: isSaving ? 'Se salvează...' : 'Salvează și deschide', type: 'default', disabled: isSaving || selectedTipComandaLocal == null || !headerClientId || !headerAgentId || (areContractRequired && !headerContractId), onClick: handleSave }" />
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="after"
            :options="{ text: 'Anulează', stylingMode: 'outlined', onClick: () => emit('update:visible', false) }" />

        <template #content>
            <div class="popup-body">

                <!-- Tip Comandă -->
                <div class="form-group-card">
                    <div class="form-group-caption">Tip Comandă <span class="required-star">*</span></div>
                    <div class="form-group-content">
                        <div class="field">
                            <DxSelectBox v-model:value="selectedTipComandaLocal" :items="categoriesArray"
                                display-expr="Denumire" value-expr="TipComanda" :search-enabled="true"
                                :show-clear-button="true" placeholder="Selectați tipul comenzii..." />
                        </div>
                    </div>
                </div>

                <!-- Contract (obligatoriu dacă categoria are AreContract=true) -->
                <div v-if="areContractRequired" class="form-group-card">
                    <div class="form-group-caption">Contract <span class="required-star">*</span></div>
                    <div class="form-group-content">
                        <div class="field">
                            <DxSelectBox v-model:value="headerContractId" :data-source="dsContracte"
                                display-expr="Numar" value-expr="ID" :search-enabled="true"
                                :show-clear-button="true" placeholder="Selectați contractul..." />
                        </div>
                    </div>
                </div>

                <!-- Informații comandă -->
                <div class="form-group-card">
                    <div class="form-group-caption">Informații Comandă</div>
                    <div class="form-group-content">
                        <div class="fg g3">
                            <div class="field span2">
                                <label>{{ partenerLabel }} <span class="required-star">*</span></label>
                                <DxDropDownBox v-model:value="headerClientId" v-model:opened="isPartenerDropDownOpened"
                                    :data-source="dsClienti"
                                    display-expr="Nume" value-expr="ID" :show-clear-button="true"
                                    :disabled="selectedTipComandaLocal == null"
                                    :placeholder="partenerLabel ? 'Selectați ' + partenerLabel.toLowerCase() + '...' : 'Selectați tipul comenzii mai întâi...'"
                                    content-template="gridContent" :drop-down-options="{ width: 500, height: 400 }">
                                    <template #gridContent>
                                        <div class="dropdown-grid-container" style="height: 300px;">
                                            <DxDataGrid :data-source="dsClienti" :columns="['Nume']"
                                                :hover-state-enabled="true" :height="280" :remote-operations="true"
                                                @row-click="onPartenerRowClick">
                                                <DxScrolling mode="virtual" />
                                                <DxFilterRow :visible="true" />
                                                <DxPaging :enabled="true" :page-size="5" />
                                                <DxSearchPanel :visible="true" placeholder="Caută..." />
                                                <DxGridToolbar>
                                                    <DxGridToolbarItem location="after">
                                                        <DxButton icon="plus" type="success" height="25px" width="25px"
                                                            @click="onAddNewPartener" />
                                                    </DxGridToolbarItem>
                                                    <DxGridToolbarItem name="searchPanel" />
                                                </DxGridToolbar>
                                            </DxDataGrid>
                                        </div>
                                    </template>
                                </DxDropDownBox>
                            </div>
                            <div class="field">
                                <label>Agent <span class="required-star">*</span></label>
                                <DxSelectBox v-model:value="headerAgentId" :data-source="dsAgenti" display-expr="Nume"
                                    value-expr="Id" :search-enabled="true" search-expr="Nume"
                                    :show-clear-button="true" placeholder="Selectați agentul..." />
                            </div>
                            <div class="field">
                                <label>Data Comenzii</label>
                                <DxDateBox v-model:value="headerDataComenzii" display-format="dd.MM.yyyy"
                                    :show-clear-button="false" />
                            </div>
                            <div class="field">
                                <label>Valută</label>
                                <DxSelectBox v-model:value="headerValutaId" :data-source="dsValute"
                                    display-expr="Simbol" value-expr="Id" :show-clear-button="true"
                                    placeholder="Selectați valuta..." />
                            </div>
                            <div class="field">
                                <label>Termen Livrare</label>
                                <DxDateBox v-model:value="headerTermenLivrare" display-format="dd.MM.yyyy"
                                    :show-clear-button="true" />
                            </div>
                            <div class="field span3">
                                <label>Observații</label>
                                <DxTextBox v-model:value="headerObservatii" :show-clear-button="true"
                                    placeholder="Observații comandă..." />
                            </div>
                            <div v-if="partenerLabel === 'Client'" class="field span3 field-switch">
                                <DxSwitch v-model:value="headerLivrareDirectaFurnizor" @value-changed="onToggleLivrareDirecta" />
                                <label class="switch-label">
                                    Livrare directă de la furnizor
                                    <span class="switch-hint">Furnizorul livrează marfa direct la client, fără să treacă prin gestiunea proprie — comanda poate fi pusă în lucru și facturată fără rezervare de stoc.</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </template>
    </DxPopup>

    <!-- Popup Adăugare Partener Nou -->
    <DxPopup :visible="isPartnerModalVisible" :width="1450" :height="684" :show-title="true"
        title="Adăugare Partener Nou" @hiding="isPartnerModalVisible = false">
        <template #title>
            <div class="popup-header">
                <div class="popup-header-main">
                    <span class="popup-header-icon dx-icon-add"></span>
                    <div class="popup-header-texts">
                        <div class="popup-header-title">Adăugare partener</div>
                        <div class="popup-header-subtitle">
                            Completează detaliile partenerului
                        </div>
                    </div>
                </div>
                <div class="popup-header-meta">
                    <span class="status-chip status-chip--draft">
                        Nou
                    </span>
                </div>
            </div>
        </template>
        <div class="popup-body-modern">
            <DxForm :form-data="newPartnerData" :col-count="3" :col-span="3">

                <DxFormItem item-type="group" caption="Identitate & Fiscal" :col-count="6"
                    css-class="form-section-simple form-section-card">
                    <DxFormItem data-field="CUI" :label="{ text: 'CUI/CNP' }" :editor-options="cuiOptions"
                        :col-span="3">
                        <DxRequiredRule message="Câmpul 'CUI/CNP' este obligatoriu" />
                    </DxFormItem>
                    <DxFormItem data-field="Nume" :col-span="3">
                        <DxRequiredRule message="Câmpul 'Nume' este obligatoriu" />
                    </DxFormItem>

                    <DxFormItem data-field="Fiscal" editor-type="dxSelectBox" :col-span="4"
                        :label="{ text: 'Tip Fiscal' }" :editor-options="{
                            dataSource: dsParteneriFiscal,
                            displayExpr: 'Nume',
                            valueExpr: 'Cod',
                            placeholder: 'Selectează Tip Fiscal',
                            searchEnabled: true,
                        }">
                        <DxRequiredRule message="Câmpul 'Tip Fiscal' este obligatoriu" />
                    </DxFormItem>
                    <DxFormItem data-field="Numar" :label="{ text: 'Regim Comerț' }" :col-span="2" />
                    <DxFormItem data-field="Caen" :label="{ text: 'Cod CAEN' }" :col-span="2" />

                    <DxFormItem data-field="Owner" :editor-options="{ readOnly: true }"
                        :label="{ text: 'Responsabil' }" :col-span="2" />
                    <DxFormItem data-field="Cont" :label="{ text: 'IBAN' }" :col-span="2" />
                    <DxFormItem data-field="Memo" :col-span="6" :editor-options="{ height: 80 }"
                        editor-type="dxTextArea" />
                </DxFormItem>

                <DxFormItem item-type="group" caption="Sediu Social" :col-span="1" :col-count="4"
                    css-class="form-section-simple form-section-card">

                    <DxFormItem data-field="Strada" :col-span="3" />
                    <DxFormItem data-field="Numarstrada" :col-span="1" :label="{ text: 'Nr.' }" />

                    <DxFormItem data-field="Bloc" :col-span="1" />
                    <DxFormItem data-field="Scarabloc" :col-span="1" :label="{ text: 'Sc.' }" />
                    <DxFormItem data-field="Et" :col-span="1" :label="{ text: 'Etaj' }" />
                    <DxFormItem data-field="Ap" :col-span="1" :label="{ text: 'Ap.' }" />

                    <DxFormItem data-field="Localitate" :col-span="3" />
                    <DxFormItem data-field="CP" :col-span="1" :label="{ text: 'C.P.' }" />

                    <DxFormItem data-field="Adresa" :col-span="4" editor-type="dxTextArea"
                        :editor-options="{ height: 80 }" :label="{ text: 'Adresă Completă' }" />
                </DxFormItem>

                <DxFormItem item-type="group" caption="Domiciliu Fiscal" :col-span="1" :col-count="4"
                    css-class="form-section-simple form-section-card">
                    <DxFormItem data-field="CStrada" :col-span="3" :label="{ text: 'Strada' }" />
                    <DxFormItem data-field="CNumarstrada" :col-span="1" :label="{ text: 'Nr.' }" />

                    <DxFormItem data-field="CBloc" :col-span="1" :label="{ text: 'Bl.' }" />
                    <DxFormItem data-field="CScarabloc" :col-span="1" :label="{ text: 'Sc.' }" />
                    <DxFormItem data-field="CEt" :col-span="1" :label="{ text: 'Etaj' }" />
                    <DxFormItem data-field="CAp" :col-span="1" :label="{ text: 'Ap.' }" />

                    <DxFormItem data-field="CLocalitate" :col-span="3" :label="{ text: 'Localitate' }" />
                    <DxFormItem data-field="CCP" :col-span="1" :label="{ text: 'C.P.' }" />

                    <DxFormItem data-field="CAdresa" :col-span="4" editor-type="dxTextArea"
                        :editor-options="{ height: 80 }" :label="{ text: 'Adresă Completă' }" />
                </DxFormItem>

                <DxFormItem :col-count="3" :col-span="3">
                    <div class="show-more-container" style="display: flex; justify-content: center; margin: 1px 0;">
                        <DxButton :element-attr="{ class: 'show-more-btn' }"
                            :text="showExtendedDetails ? 'Ascunde detalii suplimentare' : 'Completează detalii suplimentare'"
                            :icon="showExtendedDetails ? 'chevronup' : 'chevrondown'" type="normal"
                            styling-mode="text" @click="showExtendedDetails = !showExtendedDetails" />
                    </div>
                </DxFormItem>

                <DxFormItem item-type="group" caption="Configurare Financiară & Comericală"
                    :visible="showExtendedDetails" :col-count="2">
                    <DxFormItem :label="{ text: 'Bancă (Internă)' }">
                        <DxDropDownBox v-model:value="sBanci" :data-source="dsBanci" display-expr="Nume"
                            value-expr="Id" :show-clear-button="true" placeholder="Selectează bancă"
                            content-template="gridContent" :drop-down-options="{ width: 200 }">
                            <template #gridContent>
                                <div class="dropdown-grid-container" style="height: 300px;">
                                    <DxDataGrid :data-source="dsBanci" :columns="['Nume']"
                                        :hover-state-enabled="true" :height="280" :remote-operations="true"
                                        @row-click="onBanciRowClick">
                                        <DxPaging :enabled="true" :page-size="5" />
                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                        <DxGridToolbar>
                                            <DxGridToolbarItem location="after">
                                                <DxButton icon="plus" type="success" height="25px" width="25px"
                                                    @click="onAddNewBank" />
                                            </DxGridToolbarItem>
                                            <DxGridToolbarItem name="searchPanel" />
                                        </DxGridToolbar>
                                    </DxDataGrid>
                                </div>
                            </template>
                        </DxDropDownBox>
                    </DxFormItem>

                    <DxFormItem :label="{ text: 'Valută' }">
                        <DxDropDownBox v-model:value="sValutaPartener" :data-source="valutaPartenerSelectat"
                            :show-clear-button="true" display-expr="Simbol" value-expr="Id" placeholder="RON">
                            <template #content>
                                <DxDataGrid :data-source="dsValutaPartener"
                                    :selected-row-keys="sValutaPartener ? [sValutaPartener] : []"
                                    :columns="['Simbol']" :hover-state-enabled="true" height="100%"
                                    @selection-changed="onValutaPartenerSelectionChanged">
                                    <DxSelection mode="single" />
                                    <DxPaging :enabled="true" :page-size="5" />
                                    <DxFilterRow :visible="true" />
                                    <DxSearchPanel :visible="true" placeholder="Caută..." />
                                </DxDataGrid>
                            </template>
                        </DxDropDownBox>
                    </DxFormItem>

                    <DxFormItem data-field="CapitalSocial" />
                    <DxFormItem data-field="CifraAfacere" />
                    <DxFormItem data-field="NrAngajati" :label="{ text: 'Nr. Angajati' }" />

                    <DxFormItem :label="{ text: 'Grup' }" :col-span="1">
                        <DxDropDownBox v-model:value="sGrupuri" :data-source="dsGrupuri" display-expr="Nume"
                            value-expr="Id" :show-clear-button="true" placeholder="Selectează "
                            content-template="gridContent" :drop-down-options="{ width: 400 }">
                            <template #gridContent>
                                <div class="dropdown-grid-container" style="height: 300px;">
                                    <DxDataGrid :data-source="dsGrupuri" :columns="['Nume']"
                                        :hover-state-enabled="true" :height="280" :remote-operations="true"
                                        @row-click="onGrupuriRowClick">
                                        <DxPaging :enabled="true" :page-size="5" />
                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                    </DxDataGrid>
                                </div>
                            </template>
                        </DxDropDownBox>
                    </DxFormItem>

                    <DxFormItem :label="{ text: 'Zona' }" :col-span="1">
                        <DxDropDownBox v-model:value="sZona" :data-source="dsZona" display-expr="Nume"
                            value-expr="Id" :show-clear-button="true" placeholder="Selectează "
                            content-template="gridContent" :drop-down-options="{ width: 200 }">
                            <template #gridContent>
                                <div class="dropdown-grid-container" style="height: 300px;">
                                    <DxDataGrid :data-source="dsZona" :columns="['Nume']"
                                        :hover-state-enabled="true" :height="280" :remote-operations="true"
                                        @row-click="onZonaRowClick">
                                        <DxPaging :enabled="true" :page-size="5" />
                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                    </DxDataGrid>
                                </div>
                            </template>
                        </DxDropDownBox>
                    </DxFormItem>

                    <DxFormItem data-field="AdaosPret" :col-span="1" />
                    <DxFormItem data-field="Scadenta" :col-span="1" />
                </DxFormItem>

                <DxFormItem item-type="group" caption="Contacte & Diverse" :visible="showExtendedDetails"
                    :col-count="2">
                    <DxFormItem data-field="Tel" :label="{ text: 'Telefon' }" />
                    <DxFormItem data-field="Fax" />
                    <DxFormItem data-field="Email" />
                    <DxFormItem data-field="Director" />

                    <DxFormItem data-field="Observatii" :col-span="2" :editor-options="{ height: 100 }"
                        editor-type="dxTextArea" />
                </DxFormItem>

                <DxFormItem item-type="group" caption="System Flags" :visible="showExtendedDetails" :col-count="2"
                    :col-span="2">
                    <DxFormItem data-field="AplicaTVAlaIncasare" editor-type="dxCheckBox"
                        :label="{ text: 'TVA la Încasare' }" />
                    <DxFormItem data-field="RegimSpecialTVA" editor-type="dxCheckBox" />
                    <DxFormItem data-field="Intern" editor-type="dxCheckBox"
                        :editor-options="{ onValueChanged: handleInternChange }" />

                    <DxFormItem data-field="Extern" editor-type="dxCheckBox" :label="{ text: 'Extern Non UE' }"
                        :editor-options="{ onValueChanged: handleExternChange }" />

                    <DxFormItem data-field="ExternUE" editor-type="dxCheckBox" :label="{ text: 'Extern UE' }"
                        :editor-options="{ onValueChanged: handleExternUEChange }" />

                    <DxFormItem data-field="Client" editor-type="dxCheckBox" />
                    <DxFormItem data-field="Furnizor" editor-type="dxCheckBox" />
                    <DxFormItem data-field="Activ" editor-type="dxCheckBox" />

                    <DxFormItem data-field="AplicaTvaDefalcat" editor-type="dxCheckBox"
                        :label="{ text: 'Split TVA' }" />
                    <DxFormItem data-field="faraScadenta" editor-type="dxCheckBox" />
                    <DxFormItem data-field="CalculezPenalitati" editor-type="dxCheckBox" />
                    <DxFormItem data-field="Litigiu" editor-type="dxCheckBox" />
                </DxFormItem>

            </DxForm>
            <div class="form-footer footer-modern">
                <div class="footer-right" style="margin-top: 1px; text-align: right;">
                    <DxButton text="Salvează Compania" type="success" @click="onSaveNewPartner" height="32px"
                        width="200px" styling-mode="outlined" :disabled="isSubmittingPartner" />
                    <DxButton text="Închide" @click="isPartnerModalVisible = false" height="32px" width="200px"
                        styling-mode="outlined" />
                </div>
            </div>
        </div>
    </DxPopup>

    <!-- Popup Adăugare Bancă -->
    <DxPopup :visible="isBankModalVisible" :width="800" :height="550" :show-title="true" title="Adăugare Bancă"
        @hiding="isBankModalVisible = false">
        <template #title>
            <div class="popup-header">
                <div class="popup-header-main">
                    <span class="popup-header-icon dx-icon-add"></span>
                    <div class="popup-header-texts">
                        <div class="popup-header-title">Adăugare bancă</div>
                        <div class="popup-header-subtitle">
                            Completează detaliile băncii
                        </div>
                    </div>
                </div>
                <div class="popup-header-meta">
                    <span class="status-chip status-chip--draft">
                        Nou
                    </span>
                </div>
            </div>
        </template>
        <div class="popup-body-modern">
            <DxForm :form-data="newBankData" :col-count="2" :col-span="2">
                <DxFormItem data-field="Ordine" />
                <DxFormItem data-field="Cod" />
                <DxFormItem data-field="Nume" />

                <DxFormItem :label="{ text: 'Valută' }">
                    <DxDropDownBox v-model:value="sValute" :data-source="dsValuteBanca" display-expr="Simbol"
                        value-expr="Id" :show-clear-button="true" placeholder="RON" content-template="gridContent">
                        <template #gridContent>
                            <div class="dropdown-grid-container" style="height: 300px;">
                                <DxDataGrid :data-source="dsValuteBanca" :columns="['Simbol']"
                                    :hover-state-enabled="true" :height="280" :remote-operations="true"
                                    @row-click="onValuteRowClick">
                                    <DxPaging :enabled="true" :page-size="5" />
                                    <DxFilterRow :visible="true" />
                                    <DxScrolling mode="virtual" />
                                </DxDataGrid>
                            </div>
                        </template>
                    </DxDropDownBox>
                </DxFormItem>
                <DxFormItem data-field="CodIBAN" />
                <DxFormItem data-field="CodBIC" />
                <DxFormItem data-field="CodSWIFT" />
                <DxFormItem data-field="TextFC" />
                <DxFormItem data-field="Principala" editor-type="dxCheckBox" />
                <DxFormItem data-field="Activ" editor-type="dxCheckBox" />
            </DxForm>
            <div class="form-footer footer-fixed footer-modern">
                <div class="footer-right" style="margin-top: 10px; text-align: right;">
                    <DxButton text="Salvează Banca" type="success" @click="onSaveNewBank" height="32px"
                        width="200px" styling-mode="outlined" />
                    <DxButton text="Închide" @click="isBankModalVisible = false" height="32px" width="200px"
                        styling-mode="outlined" />
                </div>
            </div>
        </div>
    </DxPopup>
</template>

<script lang="ts" setup>
import { ref, computed, watch, onMounted } from 'vue';
import DxPopup, { DxToolbarItem } from 'devextreme-vue/popup';
import DxSelectBox from 'devextreme-vue/select-box';
import DxDateBox from 'devextreme-vue/date-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxButton from 'devextreme-vue/button';
import DxSwitch from 'devextreme-vue/switch';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxForm, { DxItem as DxFormItem } from 'devextreme-vue/form';
import { DxRequiredRule } from 'devextreme-vue/validator';
import DxDataGrid, {
    DxFilterRow,
    DxPaging,
    DxScrolling,
    DxSearchPanel,
    DxSelection,
    DxToolbar as DxGridToolbar,
    DxItem as DxGridToolbarItem,
} from 'devextreme-vue/data-grid';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import ProComenziService from '@/services/Comercial/ProComenzi';
import PAR_Parteneri from '@/services/PAR/PAR_Parteneri';
import JwtServices from '@/services/JwtServices';
import AnafService from '@/services/AnafService';
import { useAddPartener } from '@/composable/useAddPartener';

interface Category {
    TipComanda: number;
    Denumire: string;
    TipFurnizor?: boolean | null;
    ValutaID?: string | null;
    AreContract?: boolean | null;
}

interface Props {
    visible: boolean;
    tipComanda?: number | null;
    comandaId?: string;
}

const props = defineProps<Props>();
const emit = defineEmits<{
    (e: 'update:visible', val: boolean): void;
    (e: 'saved', data: Record<string, any>): void;
}>();

const selectedTipComandaLocal = ref<number | null>(null);
const categoriesArray = ref<Category[]>([]);
const dsValute = ref<DataSource | null>(null);
const dsClienti = ref<DataSource | null>(null);
const dsAgenti = ref<DataSource | null>(null);
const dsContracte = ref<DataSource | null>(null);

const headerClientId = ref<string | null>(null);
const isPartenerDropDownOpened = ref(false);
const headerAgentId = ref<string | null>(null);
const headerDataComenzii = ref<Date>(new Date());
const headerValutaId = ref<string | null>(null);
const headerTermenLivrare = ref<Date | null>(null);
const headerObservatii = ref<string>('');
const headerContractId = ref<string | null>(null);
const headerLivrareDirectaFurnizor = ref(false);
const isSaving = ref(false);

const NOTA_LIVRARE_DIRECTA = 'Livrare directă de la furnizor.';

function onToggleLivrareDirecta(e: any) {
    if (!e.event) return; // ignoră setările programatice (reset la deschiderea popup-ului)
    const current = (headerObservatii.value || '').trim();
    if (e.value) {
        if (!current.includes(NOTA_LIVRARE_DIRECTA)) {
            headerObservatii.value = current ? `${current} ${NOTA_LIVRARE_DIRECTA}` : NOTA_LIVRARE_DIRECTA;
        }
    } else {
        headerObservatii.value = current.replace(NOTA_LIVRARE_DIRECTA, '').replace(/\s{2,}/g, ' ').trim();
    }
}

// ── Adăugare partener nou (dropdown + popup "Adaugă Partener") ──
const { isSubmitting: isSubmittingPartner, idempotencyKey: partnerIdempotencyKey, resetIdempotencyKey: resetPartnerIdempotencyKey } = useAddPartener();

const isPartnerModalVisible = ref(false);
const showExtendedDetails = ref(false);
const dsParteneriFiscal = ref<ODataStore | null>(null);
const dsBanci = ref<DataSource | null>(null);
const dsGrupuri = ref<DataSource | null>(null);
const dsZona = ref<DataSource | null>(null);
const dsValutaPartener = ref<ODataStore | null>(null);
const valutaPartenerSelectat = ref<any[]>([]);
const sBanci = ref<string | null>(null);
const sGrupuri = ref<string | null>(null);
const sZona = ref<string | null>(null);
const sValutaPartener = ref<string | null>(null);

const newPartnerData = ref<Record<string, any>>({
    Nume: '', CUI: '', Cod: '', Fiscal: '', Numar: '', Strada: '', Localitate: '',
    JudetID: null, TaraID: null, ZonaID: null, Cont: '', Banca: '', Litigiu: null,
    Extern: null, Intern: null, Observatii: '', AdaosPret: null, faraScadenta: null,
    ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD', Director: '', Fax: '', Tel: '',
    Email: '', www: '', GrupID: null, CP: '', CStrada: '', CLocalitate: '', CJudetID: null,
    CTaraID: null, CCP: '', Bloc: '', CBloc: '', Numarstrada: '', Scarabloc: '',
    CNumarstrada: '', CScarabloc: '', Scadenta: null, AgentID: null, Angajat: null,
    Memo: '', CreditLimita: null, DirectorEconomic: '', PersoanaContact: '',
    AplicaTVAlaIncasare: null, CifraAfacere: null, NrAngajati: null, Activ: true,
    Client: true, Furnizor: true, Owner: '', CalculezPenalitati: null,
    ParRecomandareID: null, CapitalSocial: null, AngajatID: null, ExternUE: null,
    StructuraLegaturaID: null, PartenerMasterID: null, RegimSpecialTVA: null,
    AplicaTvaDefalcat: null, Et: '', Ap: '', Adresa: '', CEt: '', CAp: '', CAdresa: '',
    CalculezPenalitatiDeLa: null, Prefix: '', Sufix: '', Caen: '', PunctID: null, ParentID: null,
});

const isBankModalVisible = ref(false);
const dsValuteBanca = ref<DataSource | null>(null);
const sValute = ref<string | null>(null);
const newBankData = ref<Record<string, any>>({
    PartenerID: null, Cod: null, Nume: null, CodIBAN: null, CodBIC: null,
    Principala: null, CodSWIFT: null, ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD',
    Ordine: null, Activ: null, TextFC: null,
});

const cuiOptions = computed(() => ({
    placeholder: 'Introdu CUI',
    valueChangeEvent: 'keyup',
    onValueChanged: (e: any) => { newPartnerData.value.Cod = e.value; },
    buttons: [{
        name: 'searchAnaf',
        location: 'after',
        options: {
            icon: 'search', width: 26, height: 26, type: 'default',
            hint: 'Caută în ANAF',
            onClick: () => onSearchAnaf(),
        },
    }],
}));

const tipComandaDenumire = computed<string>(() => {
    if (selectedTipComandaLocal.value == null) return '';
    return categoriesArray.value.find(c => c.TipComanda === selectedTipComandaLocal.value)?.Denumire ?? '';
});

const partenerLabel = computed<string>(() => {
    if (selectedTipComandaLocal.value == null) return 'Partener';
    const cat = categoriesArray.value.find(c => c.TipComanda === selectedTipComandaLocal.value);
    return cat?.TipFurnizor === true ? 'Furnizor' : 'Client';
});

const areContractRequired = computed<boolean>(() => {
    if (selectedTipComandaLocal.value == null) return false;
    const cat = categoriesArray.value.find(c => c.TipComanda === selectedTipComandaLocal.value);
    return cat?.AreContract === true;
});

function initDataSources() {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; };

    ProComenziService.getCategoriiPermise().then((resp: any) => {
        categoriesArray.value = (resp.data ?? []) as Category[];
    });
    dsContracte.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'COM_Contracte', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['ID', 'Numar', 'Denumire'],
        sort: [{ selector: 'Numar', desc: false }],
    });
    dsValute.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['Id', 'Simbol'],
        sort: [{ selector: 'Simbol', desc: false }],
    });
    dsAgenti.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'COM_Agenti', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['Id', 'Nume'],
        sort: [{ selector: 'Nume', desc: false }],
    });
}

function buildDsClienti(tipFurnizor: boolean | null | undefined) {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; };
    const filtru = tipFurnizor === true ? ['Furnizor', '=', true] : ['Client', '=', true];
    dsClienti.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['ID', 'Nume', 'ValutaID'],
        filter: filtru,
        sort: [{ selector: 'Nume', desc: false }],
    });
}

function onPartenerRowClick(e: any) {
    if (!e.data) return;
    headerClientId.value = e.data.ID;
    if (e.data.ValutaID) headerValutaId.value = e.data.ValutaID;
    isPartenerDropDownOpened.value = false;
}

function initPartnerDataSources() {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; };

    dsParteneriFiscal.value = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'PAR_ParteneriFiscal', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr,
    });
    dsBanci.value = new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'PAR_BanciParteneri', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr },
        select: ['Id', 'Nume'],
    });
    dsGrupuri.value = new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'PAR_Grupuri', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr },
        select: ['Id', 'Nume', 'Cod'],
        sort: [{ selector: 'Cod', desc: false }],
    });
    dsZona.value = new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'ERP_Zone', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr },
        select: ['Id', 'Nume'],
    });
    dsValutaPartener.value = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr,
    });
    dsValuteBanca.value = new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr },
        select: ['Id', 'Simbol'],
    });
}

function onAddNewPartener() {
    newPartnerData.value = {
        ...newPartnerData.value,
        Nume: '', CUI: '', Cod: '', Fiscal: '', Owner: JwtServices.GetUsername(),
        TaraID: 'D31C3594-8D39-4355-9A13-FD699A1B7290',
        ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD',
        Client: true, Furnizor: true, Activ: true,
    };
    sBanci.value = null;
    sGrupuri.value = null;
    sZona.value = null;
    sValutaPartener.value = null;
    valutaPartenerSelectat.value = [];
    showExtendedDetails.value = false;
    resetPartnerIdempotencyKey();
    isPartnerModalVisible.value = true;
}

function onSaveNewPartner() {
    if (!newPartnerData.value.Nume || String(newPartnerData.value.Nume).trim() === '') {
        notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
        return;
    }
    if (!newPartnerData.value.Fiscal) {
        notify('Completați câmpul obligatoriu "Tip Fiscal"!', 'error', 1000);
        return;
    }

    isSubmittingPartner.value = true;
    PAR_Parteneri.save(newPartnerData.value, partnerIdempotencyKey.value).then((response: any) => {
        isSubmittingPartner.value = false;
        isPartnerModalVisible.value = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);

        const newId = response.data?.ID || response.data?.Id;
        if (newId) {
            headerClientId.value = newId;
            if (response.data.ValutaID) headerValutaId.value = response.data.ValutaID;
        }
        dsClienti.value?.reload();
    }).catch((error: any) => {
        isSubmittingPartner.value = false;
        const status = error?.response?.status;
        const data = error?.response?.data;
        if (status === 409 && data?.code === 'CUI_EXISTS') {
            notify(data.message || 'Partenerul cu acest CUI există deja!', 'error', 2000);
            return;
        }
        notify('Eroare la salvarea partenerului.', 'error', 2000);
    });
}

function onBanciRowClick(e: any) {
    if (e.data) {
        sBanci.value = e.data.Id;
        newPartnerData.value.Banca = e.data.Nume;
        newBankData.value.PartenerId = e.data.Id;
    } else {
        sBanci.value = null;
        newPartnerData.value.Banca = '';
        newBankData.value.PartenerId = null;
    }
}

function onAddNewBank() {
    newBankData.value = {
        PartenerID: null, Cod: null, Nume: null, CodIBAN: null, CodBIC: null,
        Principala: null, CodSWIFT: null, ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD',
        Ordine: null, Activ: null, TextFC: null,
    };
    sValute.value = '0A61647E-7391-4087-BC01-8EB9C2CEDEDD';
    isBankModalVisible.value = true;
}

function onSaveNewBank() {
    if (!newBankData.value.Nume || String(newBankData.value.Nume).trim() === '') {
        notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
        return;
    }

    const savedBankData = { ...newBankData.value };
    PAR_Parteneri.saveBank(newBankData.value).then((response: any) => {
        isBankModalVisible.value = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);

        const newId = response?.data?.ID || response?.data?.Id || response?.data?.id || response?.data;
        dsBanci.value?.reload().then(() => {
            if (newId) {
                sBanci.value = newId;
                newPartnerData.value.Banca = savedBankData.Nume;
            }
        });
    }).catch(() => {
        notify('Datele există deja sau a apărut o eroare!', 'error', 2000);
    });
}

function onGrupuriRowClick(e: any) {
    if (e.data) {
        sGrupuri.value = e.data.Id;
        newPartnerData.value.GrupID = e.data.Id;
    } else {
        sGrupuri.value = null;
    }
}

function onZonaRowClick(e: any) {
    if (e.data) {
        sZona.value = e.data.Id;
        newPartnerData.value.ZonaID = e.data.Id;
    } else {
        sZona.value = null;
    }
}

function onValutaPartenerSelectionChanged(e: any) {
    if (e.selectedRowKeys?.length > 0) {
        sValutaPartener.value = e.selectedRowKeys[0];
    } else {
        sValutaPartener.value = null;
    }
    newPartnerData.value.ValutaID = sValutaPartener.value;
}

function onValuteRowClick(e: any) {
    if (e.data) {
        sValute.value = e.data.Id;
        newBankData.value.ValutaID = e.data.Id;
    } else {
        sValute.value = null;
    }
}

function handleInternChange(e: any) {
    if (e.value) {
        newPartnerData.value.Extern = false;
        newPartnerData.value.ExternUE = false;
    }
}

function handleExternChange(e: any) {
    if (e.value) {
        newPartnerData.value.Intern = false;
        newPartnerData.value.ExternUE = false;
    }
}

function handleExternUEChange(e: any) {
    if (e.value) {
        newPartnerData.value.Intern = false;
        newPartnerData.value.Extern = false;
    }
}

async function onSearchAnaf() {
    const cuiRaw = newPartnerData.value.CUI;
    if (!cuiRaw) {
        notify('Te rog introdu un CUI valid', 'warning', 2000);
        return;
    }

    const cui = Number(String(cuiRaw).replace(/\D/g, ''));
    if (!cui) {
        notify('Te rog introdu un CUI valid', 'warning', 2000);
        return;
    }

    try {
        const anafResult = await AnafService.getCompanyDetails(cui);
        if (!anafResult) {
            notify('CUI-ul nu a fost găsit sau nu există date publice.', 'warning', 3000);
            return;
        }

        const dg = anafResult.date_generale;
        const ss = anafResult.adresa_sediu_social;
        const formaOrg = String(dg?.forma_organizare ?? '').toUpperCase().trim();
        const scpTVA = Boolean(anafResult?.inregistrare_scop_Tva?.scpTVA);

        let fiscal = null;
        if (formaOrg.includes('PERSOANA FIZICA')) {
            fiscal = 'F';
        } else if (formaOrg.includes('PERSOANA JURIDICA')) {
            fiscal = scpTVA ? 'P' : 'N';
        }
        if (fiscal) newPartnerData.value.Fiscal = fiscal;

        newPartnerData.value.CUI = String(dg.cui);
        newPartnerData.value.Nume = dg.denumire ?? newPartnerData.value.Nume;
        newPartnerData.value.Numar = dg.nrRegCom ?? newPartnerData.value.Numar;
        newPartnerData.value.Caen = dg.cod_CAEN ?? newPartnerData.value.Caen;
        newPartnerData.value.CAdresa = dg.adresa ?? newPartnerData.value.CAdresa;
        newPartnerData.value.Localitate = ss.sdenumire_Localitate ?? newPartnerData.value.Localitate;
        newPartnerData.value.Strada = ss.sdenumire_Strada ?? newPartnerData.value.Strada;
        newPartnerData.value.Numarstrada = ss.snumar_Strada ?? newPartnerData.value.Numarstrada;
        newPartnerData.value.CP = ss.scod_Postal ?? newPartnerData.value.CP;
        newPartnerData.value.Tel = dg.telefon ?? newPartnerData.value.Tel;

        if (dg.iban) newPartnerData.value.Cont = dg.iban;
        newPartnerData.value.AplicaTVAlaIncasare = anafResult.inregistrare_RTVAI?.statusTvaIncasare ?? false;

        const extras: string[] = [];
        if (dg.stare_inregistrare) extras.push(`Stare: ${dg.stare_inregistrare}`);
        if (typeof dg.statusRO_e_Factura === 'boolean') extras.push(`RO e-Factura: ${dg.statusRO_e_Factura ? 'DA' : 'NU'}`);

        try {
            let finData = await AnafService.getFinancialData(cui, 2024);
            if (!finData || !finData.i || finData.i.length === 0) {
                finData = await AnafService.getFinancialData(cui, 2023);
            }

            if (finData && finData.i) {
                const indicatori = finData.i;
                const caRow = indicatori.find((item: any) => {
                    const nume = item.val_den_indicator.toUpperCase();
                    return nume.includes('CIFRA DE AFACERI NET') || nume === 'VENITURI TOTALE';
                });
                const angRow = indicatori.find((item: any) => {
                    const nume = item.val_den_indicator.toUpperCase();
                    return nume.includes('NUMAR MEDIU DE SALARIATI') || nume.includes('NR. MEDIU SALARIATI');
                });

                if (caRow) {
                    newPartnerData.value.CifraAfacere = caRow.val_indicator;
                    extras.push(`CA: ${caRow.val_indicator.toLocaleString()}`);
                }
                if (angRow) {
                    newPartnerData.value.NrAngajati = angRow.val_indicator;
                    extras.push(`Angajați: ${angRow.val_indicator}`);
                }
            }
        } catch (finError) {
            console.warn('Datele financiare nu au putut fi încărcate.', finError);
        }

        if (extras.length) {
            const prev = newPartnerData.value.Memo ? String(newPartnerData.value.Memo).trim() + '\n' : '';
            newPartnerData.value.Memo = prev + extras.join(' | ');
        }

        notify('Datele au fost preluate cu succes!', 'success', 2000);
    } catch (error) {
        console.error(error);
        notify('Eroare la interogarea ANAF', 'error', 4000);
    }
}

async function loadCurrentAgent() {
    try {
        const res = await ProComenziService.getAgentCurent();
        headerAgentId.value = res.data?.AgentId ?? null;
    } catch {
        headerAgentId.value = null;
    }
}

async function handleSave() {
    isSaving.value = true;
    try {
        const resp = await ProComenziService.creeazaComanda({
            Tipcomanda: selectedTipComandaLocal.value,
            ClientId: headerClientId.value ?? null,
            AgentId: headerAgentId.value ?? null,
            DataComenzii: headerDataComenzii.value,
            ValutaId: headerValutaId.value ?? null,
            TermenLivrare: headerTermenLivrare.value ?? null,
            Observatii: headerObservatii.value || null,
            ContractId: headerContractId.value ?? null,
            LivrareDirectaFurnizor: partenerLabel.value === 'Client' ? headerLivrareDirectaFurnizor.value : false,
        });
        emit('saved', resp.data);
        emit('update:visible', false);
    } catch (err: any) {
        const raw = err?.response?.data;
        const msg = typeof raw === 'string' ? raw : (err?.message ?? 'Eroare la salvare.');
        notify(msg, 'error', 3000);
    } finally {
        isSaving.value = false;
    }
}

onMounted(() => {
    initDataSources();
    initPartnerDataSources();
});

watch(sValutaPartener, (newId) => {
    if (newId && dsValutaPartener.value) {
        (dsValutaPartener.value as ODataStore).byKey(newId).then((x: any) => {
            x.Simbol = x.Simbol ?? '(fara simbol)';
            valutaPartenerSelectat.value = [x];
        });
    } else {
        valutaPartenerSelectat.value = [];
    }
});

watch(selectedTipComandaLocal, (tipComanda) => {
    headerClientId.value = null;
    if (tipComanda == null) {
        dsClienti.value = null;
        headerValutaId.value = null;
        return;
    }
    const cat = categoriesArray.value.find(c => c.TipComanda === tipComanda);
    buildDsClienti(cat?.TipFurnizor);
    headerValutaId.value = cat?.ValutaID ?? null;
});

watch(() => props.visible, async (isVisible) => {
    if (isVisible) {
        selectedTipComandaLocal.value = props.tipComanda ?? null;
        headerClientId.value = null;
        headerDataComenzii.value = new Date();
        headerValutaId.value = null;
        headerTermenLivrare.value = null;
        headerObservatii.value = '';
        headerContractId.value = null;
        headerLivrareDirectaFurnizor.value = false;
        await loadCurrentAgent();
    }
});
</script>

<style scoped>
:deep(.dx-popup-title.dx-toolbar) {
    padding: 0 !important;
    background: transparent !important;
    border-bottom: none !important;
    min-height: unset !important;
    height: auto !important;
}

:deep(.dx-popup-title .dx-toolbar-items-container) {
    height: auto !important;
}

:deep(.dx-popup-content) {
    padding: 0 !important;
}

.popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 18px;
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    color: #fff;
}

.popup-header-main {
    display: flex;
    align-items: center;
    gap: 10px;
}

.popup-header-icon {
    font-size: 20px;
}

.popup-header-texts {
    display: flex;
    flex-direction: column;
}

.popup-header-title {
    font-size: 15px;
    font-weight: 700;
}

.popup-header-subtitle {
    font-size: 12px;
    opacity: 0.85;
}

.header-close {
    font-size: 22px;
    color: rgba(255, 255, 255, 0.8);
    cursor: pointer;
    line-height: 1;
    padding: 0 2px;
    transition: color 0.15s;
}

.header-close:hover {
    color: #fff;
}

.popup-body {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px 14px;
}

.form-group-card {
    border: 1px solid #e9ecef;
    border-radius: 4px;
    overflow: hidden;
    background: white;
}

.form-group-caption {
    background: #f8f9fa;
    color: #333;
    font-size: 14px;
    font-weight: 600;
    padding: 8px 14px;
    border-left: 3px solid #ff2c21;
}

.form-group-content {
    background: white;
    padding: 10px 14px;
}

.fg {
    display: grid;
    gap: 8px 12px;
}

.g3 {
    grid-template-columns: repeat(3, 1fr);
}

.field {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.field label {
    font-weight: 500;
    color: #333;
    font-size: 13px;
}

.span2 {
    grid-column: span 2;
}

.span3 {
    grid-column: span 3;
}

.field-switch {
    flex-direction: row;
    align-items: flex-start;
    gap: 10px;
}

.switch-label {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.switch-hint {
    font-weight: 400;
    font-size: 11px;
    color: #888;
}

.required-star {
    color: #ff2c21;
}

/* ── Popup-uri Adaugă Partener / Adaugă Bancă (pattern CRM) ── */
.popup-header-meta {
    display: flex;
    align-items: center;
}

.status-chip {
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    border: 1px solid rgba(255, 255, 255, 0.7);
}

.status-chip--draft {
    background-color: rgba(255, 255, 255, 0.18);
}

.footer-modern {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.02);
}

:deep(.form-section-simple .dx-form-group-caption) {
    background: #f8f9fa;
    color: #333;
    font-size: 14px;
    font-weight: 600;
    padding: 10px 15px;
    margin: 15px 0 10px 0;
    border-left: 3px solid #ff2c21;
    border-radius: 0;
}

:deep(.form-section-simple .dx-form-group-content) {
    background: white;
    padding: 15px 0;
    margin-bottom: 10px;
}

.form-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.footer-right .dx-button {
    margin-left: 8px;
}

:deep(.show-more-btn .dx-button-text) {
    white-space: normal !important;
}

:deep(.show-more-btn .dx-button-content) {
    white-space: normal !important;
    flex-wrap: wrap;
}

:deep(.show-more-btn) {
    height: 25px;
    width: 400px;
}

.popup-body-modern {
    padding: 14px 18px 56px 18px;
}

.footer-fixed {
    position: sticky;
    bottom: 0;
    padding: 10px 16px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    z-index: 10;
}

.dropdown-grid-container {
    height: 300px;
}
</style>
